<template>
  <div class="pa-7" id="function">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
    <v-row>
      <v-col cols="12">
      <p>
        ・ビデオ変換機能
      </p>
      <p>
        ・ビデオの視聴確認
      </p>
      <p>
        ・ビデオ視聴回数制限
      </p>
     <p>
        ・コンテンツの全文検索(全文検索の詳細は<router-link :to="{ path: '/Products/Search'}" append>こちら</router-link>)
      </p>
     <p>
        ・LDAP連携
      </p>
      <p>
        ・出席管理
      </p>
      </v-col>
    </v-row>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}

.summary {
  vertical-align: middle;
  font-size: 16px;
}
v-list-item{
  margin-bottom:-8px;
}
p{
  border-bottom:solid 1px #BBDE;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '機能',
      // タイトル横のアイコン
      icon: 'mdi-cog-outline'
    }
  }
}
</script>
